
import * as utils from './utils.js';
import config from './config.js';
import * as validation from './validation.js'
import * as apihandler from './api-handler.js'
import * as sw from './sw.js';
import * as canvasRender from './canvas-render.js';
/**
 * Utility functions for UI components.
 */

const location = window.location;

const navigator = window.navigator;
const historyContainer = document.getElementById("historyContainer");
/**
 * Writes a warning alert into the specified element by class name.
 * @param {string} currentClass The class name of the element to write the alert into.
 */
export function writeAlert(currentClass) {
  // helpcontent
  const helperContent = document.getElementsByClassName(currentClass)[0];
  if (helperContent != null) {
    helperContent.innerHTML = `<span style="font-size:24px;" >&#9888;</span>
      <span class="title" style="font-size:var(--normal-fontsize);"> 
    تحذير :الموقع لا يطلب منك رقم الجوال (الهاتف) أو بيانات شخصية ولا يطلب منك تحميل تطبيقات والخدمة مجانية لذلك لا تضع رقم جوالك (الهاتف )
    </span>`;
  }
}
/**
 * check and show modal based on cookie value if the cookie exists don't show the modal
 * @param {string} cookieName 
 */
export function showModel(cookie) {
  if (cookie != "1") {
    // to avoid duplicate of creating modal-backdrop
    const isExists = document.querySelector('.modal-backdrop');
    if (isExists == null) {
      // eslint-disable-next-line no-undef
      const myModal = new bootstrap.Modal(
        document.getElementById("modal"),
        {
          backdrop: "static",
          keyboard: false,
        }
      );
      myModal.show();
    }
  }
}
/**
 * show force modal without checking cookie
 */
export function showForceModel() {
  // to avoid duplicate of creating modal-backdrop
  const isExists = document.querySelector('.modal-backdrop');
  if (isExists == null) {
    // eslint-disable-next-line no-undef
    var myModal = new bootstrap.Modal(
      document.getElementById("modal"),
      {
        backdrop: "static",
        keyboard: false,
      }
    );
    myModal.show();
  }
}
/**
 * return install app message for user
 * @returns {string}
 */
export function createInstallAppMessage() {

  if (utils.isAndroid() || utils.isDesktop()) {
    return ` <div style="font-size: 1.15rem; line-height: 1.7; padding: 5px;">
    <div style="text-align:center; margin-bottom: 3px;">
      <img src="/icons/android-chrome-348x348.png" 
           alt="app" width="100" style="margin-bottom: 3px;">
    </div>
    <p style="margin-top: 3px;margin-bottom:3px;">
       نقدم لك <strong>نسخة تطبيق</strong> تعمل مباشرة على هاتفك بدون تحميل.
    </p>
    <p style="margin-top: 5px; color: #444;margin-bottom:3px;">
      ✔️ سرعة أفضل في التصفح  
      <br>✔️ تجربة مستقرة بدون مشاكل  
      <br>✔️ يعمل حتى عند ضعف الإنترنت  
      <br>✔️ تظهر على شاشة هاتفك مثل أي تطبيق آخر  
    </p>
    <p style="margin-top: 5px;margin-bottom:3px; font-weight: bold; text-align:center;">
      👇 اضغط موافق للحصول على تجربة أفضل
    </p>
  </div>`;
  } else {
    return `<div style="font-size: 1.15rem;line-height: 1.7;padding: 5px;text-align:center;direction: rtl;">
    <img src="/icons/android-chrome-348x348.png" width="100" style="margin-bottom:3px">
    <p><strong>📱 هل ترغب في إضافة التطبيق إلى شاشة هاتفك؟</strong></p>
    <p style="margin-top:3px;text-align: right;margin-bottom:3px;">
        يمكنك تثبيت التطبيق على جهاز الايفون بسهولة، ليعمل مثل أي تطبيق آخر.
    </p>
    <p style="text-align: right;margin-top:4px;margin-bottom:3px;">
        <strong>خطوات التثبيت:</strong><br>
        1️⃣ اضغط على زر <strong>المشاركة</strong> (🔼) أسفل المتصفح.<br>
        2️⃣ اختر <strong>Add to Home Screen</strong> (إضافة إلى الشاشة الرئيسية).<br>
        3️⃣ اضغط <strong>Add (إضافة)</strong> وسيظهر التطبيق مباشرة.
    </p>
    <p style="margin-top:4px; font-weight:bold;margin-bottom:3px;">
        👇 اتبع الخطوات بالأعلى لإتمام التثبيت.
    </p>
</div>`;
  }
}
export function createSubscribeMessage() {
  return `<div style="font-size: 1.15rem; line-height: 1.7; padding: 2px 10px;">
    <div style="text-align:center; margin-bottom: 8px;">
       <img src="/icons/android-chrome-348x348.png" 
           alt="bell" width="100" style="margin-bottom: 6px;">
    </div>

    <p><strong>🔔 هل تريد تفعيل إشعارات التطبيق؟</strong></p>

    <p style="margin-top: 3px;">
      بتفعيل التنبيهات هيوصلك:
      <br>✨ إشعارات بالتحديثات الجديدة
      <br>🎁 تنبيهات بالميزات الحصرية
      <br>⚡ تنبيهات سريعة لو في تحديثات مهمة
    </p>

    <p style="margin-top: 4px; color: #444;">
      ✔️ الإشعارات مش هتزعجك  
      <br>✔️ تقدر توقفها في أي وقت  
      <br>✔️ مش بنطلب تسجيل دخول أو بيانات  
    </p>

    <p style="margin-top: 4px; font-weight: bold; text-align:center;">
      👇 اضغط موافق لتشغيل التنبيهات الآن
    </p>

  </div>` ;
}
/**
 * create modal message 
 * @param {string} key 
 * @param {string} title
 * @param {string} message
 * @param {Function} answerYesFunction
 * @param {Function} answerNoFunction
 */
export async function createSubscribeModal(key, title, message, answerYesFunction, answerNoFunction) {

  if (utils.getLocalStorageValue(key) != null)
    return;

  const already = await sw.userIsSubscribed();
  if (already) {
    console.log('User already subscribed — do not show subscribe flow.');
    return;
  }
  if (Notification.permission === 'denied') {
    // user denied the Notification , it's okay
    return;
  }
  let container = document.getElementsByClassName("main-container");
  if (!container.length) return;

  let mdContainer = document.createElement("div");
  const id = "subscribeModal";
  mdContainer.classList.add("modal", "fade", "show");
  mdContainer.setAttribute("id", id);
  mdContainer.setAttribute("tabindex", "-1");
  mdContainer.setAttribute("role", "dialog");
  mdContainer.setAttribute("aria-hidden", "true");
  mdContainer.style.display = "block"; // Show modal

  let modal_Dialog = document.createElement("div");
  modal_Dialog.classList.add("modal-dialog", "modal-dialog-centered");
  modal_Dialog.setAttribute("role", "document");
  mdContainer.appendChild(modal_Dialog);

  let modal_content = document.createElement("div");
  modal_content.classList.add("modal-content");
  modal_Dialog.appendChild(modal_content);

  let modal_header = document.createElement("div");
  modal_header.classList.add("modal-header");
  modal_content.appendChild(modal_header);

  let modal_h5 = document.createElement("h5");
  modal_h5.innerHTML = title;// " تفعيل التنبيهات";
  modal_h5.classList.add("modal-title");
  modal_header.appendChild(modal_h5);
  let modal_body = document.createElement("div");
  modal_body.classList.add("modal-body");
  modal_body.innerHTML = message;

  modal_content.appendChild(modal_body);
  let modal_footer = document.createElement("div");
  modal_footer.classList.add("modal-footer");
  let openBtn = document.createElement("button");
  openBtn.classList.add("btn", "btn-success");
  let deferredPrompt = null;
  openBtn.innerText = "موافق";
  openBtn.onclick = () => {
    answerYesFunction(mdContainer)
  };

  let continueBtn = document.createElement("button");
  continueBtn.classList.add("btn", "btn-secondary");
  continueBtn.innerText = "غير موافق";
  continueBtn.onclick = () => { answerNoFunction(mdContainer); };


  modal_footer.appendChild(openBtn);
  modal_footer.appendChild(continueBtn);

  modal_content.appendChild(modal_footer);
  document.body.appendChild(mdContainer);
  document.body.classList.add("modal-open");
  let backdrop = document.createElement("div");
  backdrop.classList.add("modal-backdrop", "fade", "show");
  document.body.appendChild(backdrop);
}
/**
 * create modal message 
 * @param {string} id 
 * @param {string} message 
 * @param {string} titlHeader 
 * @param {string} img 
 */
export function createModalMessage(id, message, titlHeader, img) {
  const container = document.getElementsByClassName("main-container");
  if (!container.length) return;
  const mdContainer = document.createElement("div");
  mdContainer.classList.add("modal", "fade", "show");
  mdContainer.setAttribute("id", id);
  mdContainer.setAttribute("tabindex", "-1");
  mdContainer.setAttribute("role", "dialog");
  mdContainer.setAttribute("aria-labelledby", "modalLabel");
  mdContainer.setAttribute("aria-hidden", "true");
  const modal_Dialog = document.createElement("div");
  modal_Dialog.classList.add("modal-dialog", "modal-dialog-centered");
  modal_Dialog.setAttribute("role", "document");
  mdContainer.appendChild(modal_Dialog);
  /*********************************/
  const modal_content = document.createElement("div");
  modal_content.classList.add("modal-content");
  modal_Dialog.appendChild(modal_content);
  const modal_header = document.createElement("div");
  modal_header.classList.add("modal-header");
  modal_content.appendChild(modal_header);
  const modal_h5 = document.createElement("h5");
  modal_h5.classList.add("modal-title");
  modal_h5.innerText = titlHeader;
  modal_header.appendChild(modal_h5);
  const modal_body = document.createElement("div");
  modal_body.classList.add("modal-body");
  if (img != undefined) {

    const comicImage = document.createElement("img");
    comicImage.setAttribute("style", "max-width: 100%;margin-bottom: 5px;border-radius: 7px;")
    comicImage.setAttribute("src", img);
    modal_body.appendChild(comicImage);
  }

  const modal_paragraph = document.createElement("p");
  modal_paragraph.innerText = message;
  modal_body.appendChild(modal_paragraph);
  let aShare = document.createElement("a");
  modal_content.appendChild(modal_body);
  let rowBody = document.createElement("div");
  /********************************/
  rowBody.classList.add("row");
  modal_body.appendChild(rowBody);
  let col_body = document.createElement("div");
  col_body.classList.add("col-12");
  rowBody.appendChild(col_body);
  /******************************/
  let modal_footer = document.createElement("div");
  modal_footer.classList.add("modal-footer");
  modal_content.appendChild(modal_footer);
  // aShare.setAttribute("id", "sharebtn");
  aShare.classList.add("btn", "btn-primary", "btn-sh");

  aShare.setAttribute("href", "#");
  aShare.innerText = "موافق ";
  aShare.addEventListener('click', function () {
    // eslint-disable-next-line no-undef
    hideModal(id);
  });
  modal_footer.appendChild(aShare);
  // mdContainer.append(hideScript);
  container[0].appendChild(mdContainer);
}
/**
 * show modal warning message to user
 * @returns 
 */
export function showWarningMessage() {
  // create modal 
  let currentCookieMessageCount = utils.getCookie(config.MessageCountCookie);
  if (currentCookieMessageCount == null) {
    utils.setCookie(config.MessageCountCookie, 1, 1);
  } else {
    if (currentCookieMessageCount < 3) {
      currentCookieMessageCount += 1;
      utils.setCookie(config.MessageCountCookie, currentCookieMessageCount, 1);
    } else {
      return;
    }
  }
  let message = `<p style="font-weight:700;margin-bottom: 12px;font-size: 1.1rem; padding-left: 11px;padding-right: 11px;">مرحبًا بك عزيزي الزائر</p>
  <p style="
    padding-left: 11px;
    padding-right: 11px;
    color: #cf0000;
    font-size: 0.95rem;
    font-weight: 700;">
يرجى العلم بأن الموقع مجاني تمامًا ولا يتطلب أي اشتراكات أو رقم هاتف أو أي معلومات شخصية و بدون تحميل أي تطبيقات.
  </p>
  <p style="font-size: 0.85rem;color: #000;font-weight: 700;padding-left: 11px;padding-right: 11px;margin-bottom: 0;">
  في حال كان لديك أي استفسارات يُرجى التواصل معنا عبر صفحتنا على فيسبوك.
  </p>
  `;
  createModalUserMessage(settingData, "modalWarning", "yes", message, "معلومة هامة ");
  var modal = document.getElementById("modalWarning");
  if (modal) modal.removeAttribute("aria-hidden");

  var scripts = document.getElementsByTagName('script');
  var isBootstrapLoaded = false;

  for (var i = 0; i < scripts.length; i++) {
    if (scripts[i].src.includes("bootstrap.min.js")) {
      isBootstrapLoaded = true;
      break;
    }
  }
  if (!isBootstrapLoaded) {
    const script = document.createElement('script');
    script.src = "https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/js/bootstrap.bundle.min.js";
    script.type = "text/javascript";
    script.onload = function () {
      const modalElement = document.getElementById("modalWarning");
      // eslint-disable-next-line no-undef
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    };
    script.onerror = function () {
      // console.log("Error loading Bootstrap JS.");
    };
    document.head.appendChild(script);
  } else {
    const modalElement = document.getElementById("modalWarning");
    // eslint-disable-next-line no-undef
    const modal = new bootstrap.Modal(modalElement);
    modal.show();
    // to fix background problems 
    var backdrop = document.getElementsByClassName("modal-backdrop")[0];
    backdrop.classList.remove("in");
    backdrop.classList.add("show");
  }
}

export function createModalUserMessage(settingData, id = "modal", custom = "no", message = "", title = "") {
  if (config.ShowModal || custom == "yes") {

    const container = document.getElementsByClassName("main-container");
    if (!container.length) return;

    const mdContainer = document.createElement("div");
    mdContainer.classList.add(id, "fade", "show");
    mdContainer.setAttribute("id", id);
    mdContainer.setAttribute("tabindex", "-1");
    mdContainer.setAttribute("role", "dialog");
    mdContainer.setAttribute("aria-labelledby", "modalLabel");
    mdContainer.setAttribute("aria-hidden", "true");
    /**********************************/
    const modal_Dialog = document.createElement("div");
    modal_Dialog.classList.add("modal-dialog", "modal-dialog-centered");
    modal_Dialog.setAttribute("role", "document");
    mdContainer.appendChild(modal_Dialog);
    /*********************************/
    let modal_content = document.createElement("div");
    modal_content.classList.add("modal-content");
    modal_Dialog.appendChild(modal_content);
    /*********************************/
    let modal_header = document.createElement("div");
    modal_header.classList.add("modal-header");
    modal_content.appendChild(modal_header);
    let modal_h5 = document.createElement("h5");
    modal_h5.classList.add("modal-title");
    modal_h5.innerText = custom == "no" ? config.TitleModal : title;
    modal_header.appendChild(modal_h5);
    /********************************/
    let modal_body = document.createElement("div");

    let url = location.href.replace("&fbback=y", "");
    url = url.replace("&error_code=4201", ""
    ).replace(
      "&error_message=User+canceled+the+Dialog+flow#_=_",
      ""
    );
    url += "&fbback=y"; // to ensure ios cookies problem
    let pageurl = encodeURIComponent(url);

    let fburl = utils.createFbUrl(
      config.appId,
      settingData,
      //  settingData_group_for,
      config.pageId,
      config.designName,
      pageurl
    );
    modal_body.classList.add("modal-body");
    let modal_paragraph = custom == "no" ? document.createElement("p") : document.createElement("div")
    if (custom == "no")
      modal_paragraph.innerText = config.BodyModal;
    else
      modal_paragraph.innerHTML = message

    modal_body.appendChild(modal_paragraph);
    let aShare = document.createElement("a");
    let adisagree = document.createElement("a");

    modal_content.appendChild(modal_body);
    let rowBody = document.createElement("div");
    /********************************/
    rowBody.classList.add("row");
    modal_body.appendChild(rowBody);
    let col_body = document.createElement("div");
    col_body.classList.add("col-12");
    rowBody.appendChild(col_body);
    /******************************/
    let modal_footer = document.createElement("div");
    modal_footer.classList.add("modal-footer");


    // aShare.setAttribute("id", "sharebtn");
    aShare.classList.add("btn", "btn-primary", "btn-sh");
    if (custom == "no") {
      modal_footer.setAttribute("style", "justify-content: flex-start;");
      adisagree.classList.add("btn", "btn-secondary", "btn-disagree");
    }
    else {
      adisagree.setAttribute("style", "width:100%;");
      modal_footer.setAttribute("style", "justify-content: center;");
      adisagree.classList.add("btn", "btn-primary", "btn-disagree");
    }
    modal_content.appendChild(modal_footer);
    aShare.setAttribute("href", "#");
    aShare.innerText = "شارك الان";
    adisagree.innerText = custom == "no" ? "غير موافق" : "موافق";

    adisagree.setAttribute("href", "#");

    // data-controls-modal modal
    //data-backdrop="static" data-keyboard="false" href="#"
    if (custom == "no")
      modal_footer.appendChild(aShare);

    // var scriptDiv = document.createElement("script");
    let design = utils.getDesignName();
    if (custom == "no") {
      aShare.addEventListener('click', function () {
        //  console.log(fburl);

        utils.fixDuplicateShare(fburl);
      });
    }

    adisagree.addEventListener('click', async function (e) {
      e.preventDefault();
      let data = {
        "design": design,
        "shared": "false",
        "sId": config.sessionid
      };
      // await submitShareStatus(data);
      //utils.setCookie(`${config.noShareStatus}-${design}`, "1", 1);
      utils.setLocalStorageWithFlagExpiry(`${config.noShareStatus}-${design}`, "1", 1);

      // Hide the Bootstrap modal using pure JavaScript
      // eslint-disable-next-line no-undef
      const modal = bootstrap.Modal.getInstance(document.getElementById(id));
      modal.hide();
    });
    //}

    if (custom == "no") {
      if (config.isUserNotApplicable || !config.isForceShare) {
        // setCookie(`fb - ${ design } `,"1",1);
        modal_footer.appendChild(adisagree);
      }
    } else {
      modal_footer.appendChild(adisagree);

    }
    // add new button to reload the page when user want website to validate the share 
    // in case force share is false, we don't need to add this button to allow user to reload the page and check the share
    if (config.isForceShare != false) {
      let reloadBtn = document.createElement("button");
      reloadBtn.classList.add("btn", "btn-success");
      reloadBtn.innerText = "تمت المشاركة";
      reloadBtn.onclick = () => {
        location.reload();
      };
      modal_footer.appendChild(reloadBtn);
    }

    // mdContainer.append(scriptDiv);
    container[0].appendChild(mdContainer);

  }

}
/**
 * show modal navigate user from facebook app to chrome or other browser
 * @param {string} key 
 * @returns 
 */
export function createNavigationWindow(key) {
  if (utils.getCookie(key) != null)
    return;
  let container = document.getElementsByClassName("main-container");
  if (!container.length) return;

  let mdContainer = document.createElement("div");
  const id = "navigateModal";
  mdContainer.classList.add("modal", "fade", "show");
  mdContainer.setAttribute("id", id);
  mdContainer.setAttribute("tabindex", "-1");
  mdContainer.setAttribute("role", "dialog");
  mdContainer.setAttribute("aria-hidden", "true");
  mdContainer.style.display = "block"; // Show modal

  let modal_Dialog = document.createElement("div");
  modal_Dialog.classList.add("modal-dialog", "modal-dialog-centered");
  modal_Dialog.setAttribute("role", "document");
  mdContainer.appendChild(modal_Dialog);

  let modal_content = document.createElement("div");
  modal_content.classList.add("modal-content");
  modal_Dialog.appendChild(modal_content);

  let modal_header = document.createElement("div");
  modal_header.classList.add("modal-header");
  modal_content.appendChild(modal_header);

  let modal_h5 = document.createElement("h5");
  modal_h5.innerHTML = "⚠️ تنبيه مهم";
  modal_h5.classList.add("modal-title");
  modal_header.appendChild(modal_h5);
  let modal_body = document.createElement("div");
  modal_body.classList.add("modal-body");
  modal_body.innerHTML = `<div style = "font-size: 1.1rem; line-height: 1.6;" >
    <p><strong>⚠️ تنبيه:</strong> أنت الان تتصفح الموقع من داخل تطبيق فيسبوك ومن ضمن العيوب :</p>
    <p style="margin-top: 5px;">
      📷 لا يمكنك حفظ الصور بطريقة سهلة <br>
      🐢 بطيء في الاستخدام  <br>
      🔄 لا يظهر تحديثات الموقع 
    </p>
    <p style="margin-top: 5px;">
      ✅ أفتح الموقع في <strong>جوجل كروم</strong> حتى يعمل معك الموقع بطريقة صحيحة.
    </p>
    <p style="margin-top: 10px;">
      <strong>👇 اضغط موافق وسينقلك الان</strong>
    </p>
  </div>`;

  modal_content.appendChild(modal_body);
  let modal_footer = document.createElement("div");
  modal_footer.classList.add("modal-footer");
  let openBtn = document.createElement("button");
  openBtn.classList.add("btn", "btn-success");
  openBtn.innerText = "موافق";
  openBtn.onclick = function () {
    const url = window.location.href;
    const intentUrl = `intent://${url.replace(/^https?:\/\//, '')}#Intent;scheme=https;package=com.android.chrome;end`;
    window.location.href = intentUrl;
  };

  let continueBtn = document.createElement("button");
  continueBtn.classList.add("btn", "btn-secondary");
  continueBtn.innerText = "غير موافق";
  continueBtn.onclick = () => {
    utils.setCookie(config.navigateExternalKey, "1", 12);
    mdContainer.remove();
    document.querySelector(".modal-backdrop")?.remove();
    document.body.classList.remove("modal-open");
  };

  modal_footer.appendChild(openBtn);
  modal_footer.appendChild(continueBtn);

  modal_content.appendChild(modal_footer);
  document.body.appendChild(mdContainer);
  document.body.classList.add("modal-open");
  let backdrop = document.createElement("div");
  backdrop.classList.add("modal-backdrop", "fade", "show");
  document.body.appendChild(backdrop);
}
/**
 * create a captcha modal to confirm user is a human
 * @param {string} token
    * @returns
    */
export function showCaptchaModal(token) {
  if (document.getElementById("captchaModal")) return;
  // Modal structure
  //const captchaCode = Math.random().toString(36).substring(2, 7).toUpperCase();
  let captchaCode = utils.generateCaptcha();
  // Render the code on a FRESH canvas every time: repainting the same
  // canvas after a failed attempt produced a collapsed, illegible code on
  // real devices, while a first draw was always clean - so a regenerated
  // code swaps in a brand-new canvas instead of repainting the old one.
  const renderCaptcha = () => {
    const canvas = document.createElement("canvas");
    canvas.width = 120;
    canvas.height = 50;
    const ctx = canvas.getContext("2d");
    ctx.font = "30px Arial";
    ctx.fillStyle = "#000";
    ctx.fillText(captchaCode, 10, 30);
    const container = document.getElementById("captchaContainer");
    if (container) {
      container.innerHTML = "";
      container.appendChild(canvas);
    }
  };
  // Build modal HTML
  const modal = document.createElement("div");
  modal.className = "modal fade show";
  modal.id = "captchaModal";
  modal.style.display = "block";
  modal.tabIndex = -1;
  modal.setAttribute("role", "dialog");
  modal.setAttribute("aria-hidden", "true");

  modal.innerHTML = `
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">🔐 التحقق من المستخدم</h5>
        </div>
        <div class="modal-body">
          <p>الرجاء إدخال رمز التحقق أدناه:</p>
          <div id="captchaContainer" class="mb-3 text-center"></div>
          <input type="text" inputmode="numeric" autocomplete="off" style="text-align:center;font-size:1.3rem;direction:ltr;" id="captchaInput" class="form-control mb-2" placeholder="اكتب رمز التحقق هنا">
            <div id="captchaError" class="text-danger" style="display: none;">رمز التحقق غير صحيح، يرجى المحاولة مرة أخرى</div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary w-100" id="submitCaptcha">تأكيد</button>
        </div>
      </div>
    </div>
    `;

  document.body.appendChild(modal);
  document.body.classList.add("modal-open");

  const backdrop = document.createElement("div");
  backdrop.className = "modal-backdrop fade show";
  document.body.appendChild(backdrop);

  // Append CAPTCHA image
  renderCaptcha();
  // Auto-focus for mobile
  window.setTimeout(() => {
    document.getElementById("captchaInput").focus();
  }, 100);
  // Submit button logic
  document.getElementById("submitCaptcha").onclick = () => {
    const userInput = document.getElementById("captchaInput").value.trim().toUpperCase();
    const cleanedInput = utils.normalizeInput(userInput);
    if (cleanedInput === captchaCode) {
      // Clean up modal and redirect
      document.getElementById("captchaModal")?.remove();
      document.querySelector(".modal-backdrop")?.remove();
      document.body.classList.remove("modal-open");

      // Redirect to download.html
      window.location.href = "download.html" + "?token=" + token;
    } else {
      // Wrong code: show the error, issue a fresh code, and hand the user a
      // cleared, focused input so the retry is one step.
      document.getElementById("captchaError").style.display = "block";
      captchaCode = utils.generateCaptcha();
      renderCaptcha();
      const input = document.getElementById("captchaInput");
      input.value = "";
      input.focus();
    }
  };
  document.getElementById("captchaInput").addEventListener("keydown", function (e) {
    if (e.key === "Enter") {
      e.preventDefault();
      document.getElementById("submitCaptcha").click();
    }
  });
}

// SendToFreind api error
export function createSendToFriendModal(settingData) {

  //settingData.general.sendToFriend = 1;
  //if(settingData.general.sendToFriend!=null)
  // {
  // validate the design exists
  if (config.cloneDesign == null)
    return;
  let container = document.getElementsByClassName("main-container");
  if (!container.length) return;
  let mdContainer = document.createElement("div");
  const id = "sendToFriendModal";
  const modalHTML = `
    <div class="modal fade" id="${id}" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered"> <!-- Centered modal -->
        <div class="modal-content">

          <form id="dynamicContactForm">
            <div class="modal-header">
              <h5 class="modal-title">إرسلها إلى صديق</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
              <span id="aboutLink" style="font-size: 0.85rem;">🎁 سيتم إنشاء رابط دائم يمكنك مشاركته مع صديقك.
                يتيح له مشاهدة التصميم الحالي، وقراءة رسالتك.
              </span>
              <!-- Form Wrapper -->
              <div id="formWrapper">
                <div class="mb-3">
                  <label for="txtName" class="form-label">اسمك:</label>
                  <input type="text" class="form-control" placeholder="أكتب أسمك هنا" id="txtName" required>
                    <span id="lblNameValidate" class="text-danger field-validation-valid"></span>
                </div>

                <div class="mb-3">
                  <label for="txtMessage" class="form-label">رسالة إلى صديقك:</label>
                  <textarea class="form-control" placeholder="أكتب رسالتك هنا" id="txtMessage" rows="4" ></textarea>
                </div>

                <div class="mb-3">
                  <label class="form-label">أرسل عن طريق:</label>
                    <div>
                    <input type="radio" class="form-check-input" name="platform" value="whatsapp" id="optWhatsApp" checked>
                      <label for="optWhatsApp" class="form-check-label">الواتساب</label>
                  </div>
                  <div>
                    <input type="radio" class="form-check-input" name="platform" value="facebook" id="optFacebook" >
                      <label for="optFacebook" class="form-check-label">ماسنجر الفيسبوك</label>
                  </div>
               
                </div>
              </div>

              <!-- Success Message -->
              <div id="successMessage" class="d-none text-center">
                <div class="mb-3">
                  <div class="rounded-circle bg-success d-inline-flex justify-content-center align-items-center" style="width: 80px; height: 80px;">
                    <i class="fa-solid fa-check" style="color:#fff;font-size:2.5rem"></i>
                  </div>
                </div>

                <!-- Main Message -->
                <h5 class="mb-3 text-success">تم حفظ معلوماتك بنجاح</h5>
                <p class="text-muted mb-4">يرجى الانتظار، سيتم الآن فتح التطبيق لإرسال رابط التهنئة المخصص لصديقك.</p>

                <!-- Fallback Suggestion -->
                <div class="alert alert-warning text-start mx-auto" style="max-width: 400px;">
                  <strong>⚠️ لم يتم فتح التطبيق تلقائيًا؟</strong><br>
                    انسخ الرسالة والرابط يدويًا وأرسلها لصديقك بنفسك.
                </div>

                <!-- Copy Button -->
                <div id="copyStatus" class="text-muted" style="font-size:0.90rem;margin-bottom:11px;margin-top:3px;"></div>
                <button id='btnCopy' class="btn btn-primary px-4">  📋 أضغط هنا لنسخ الرسالة والرابط</button>

              </div>

            </div>

            <div class="modal-footer">
              <button type="submit" id="sendBtn" class="btn btn-success d-flex justify-content-center align-items-center">
                <span id="btnText">حفظ</span>
                <div id="btnSpinner" class="spinner-border spinner-border-sm ms-2 d-none" role="status"></div>
              </button>
              <a id="deepLink" class="btn btn-success d-none d-flex justify-content-center align-items-center">إرسال</a>
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">غلق</button>
            </div>
          </form>

        </div>
      </div>
    </div>
    `;

  mdContainer.innerHTML = modalHTML;
  container[0].appendChild(mdContainer);
  // events of the form
  const sendBtn = document.getElementById('sendBtn');
  if (!sendBtn) return;
  const senderName = document.getElementById('txtName');
  const message = document.getElementById('txtMessage');
  const btnText = document.getElementById('btnText');
  const btnSpinner = document.getElementById('btnSpinner');
  const lblNameValidate = document.getElementById('lblNameValidate');
  const deepLink = document.getElementById('deepLink');
  const successMessage = document.getElementById('successMessage');

  const aboutLink = document.getElementById("aboutLink");
  const btnCopy = document.getElementById('btnCopy');
  const modalFooter = document.querySelector('.modal-footer');
  const copyStatus = document.getElementById('copyStatus');
  // sendBtn.classList.add("btn", "btn-primary");
  // sendBtn.innerText = "ارسال";

  const form = document.getElementById('dynamicContactForm');
  if (form) form.addEventListener('submit', async function (e) {
    e.preventDefault();
    let validationObj = validation.validateName(senderName.value);
    if (!validationObj.isValid) {
      lblNameValidate.textContent = validationObj.message;
      return;
    }
    const platformInput = document.querySelector('input[name="platform"]:checked');
    sendBtn.disabled = true;
    btnSpinner.classList.remove('d-none');
    btnText.textContent = "جاري الحفظ...";
    //const socialMessage = "أرسلت إليك رسالة تهنئة وتصميم خاص بمناسبة عيد الأضحى\nتم إنشاء التصميم من خلال موقع صمّم بنفسك .. شاهد التهنئة من هنا 👇👇";

    const sharekey = utils.getShareKey(config?.designName);
    let sharePath = config.sharedLinkDetails.find(x => x.name == sharekey)?.path;
    let messageTemplate = config.sharedLinkDetails.find(x => x.name == sharekey)?.message;

    let imageName = config.cloneDesign.imagesDesigned[0];
    let domainHost = config.cloneDesign.domainUrl.replace("/images/shared", "");
    let data = { designName: config.designName, sId: config.sessionid, senderName: senderName.value, message: message.value, imageDomain: domainHost, imageName: imageName }
    let result = await apihandler.submitSendToFriend(data);
    if (result != null) {
      const id = result.id;
      let finalUrl = `https://h.tasawehala.com/${sharePath}/${id}`;
      sendBtn.disabled = false;
      btnSpinner.classList.add('d-none');
      aboutLink.classList.add('d-none');
      modalFooter.classList.add('d-none');
      document.getElementById('formWrapper').classList.add('d-none');
      document.getElementById('sendBtn').classList.add('d-none');
      document.getElementById('successMessage').classList.remove('d-none');
      document.getElementById('deepLink').classList.remove('d-none');

      if (platformInput.value === 'whatsapp') {
        let linkObj = utils.createWhatsAppLink(messageTemplate, finalUrl);
        btnCopy.addEventListener('click', function (e) { utils.copyToClipboard(linkObj.message, platformInput.value, copyStatus); });
        utils.tryOpenAppOrFallback(linkObj.deepLink, linkObj.fallbackLink);
      } else if (platformInput.value === 'facebook') {
        let linkObj = utils.createFacebookMessengerLink(messageTemplate, finalUrl);
        btnCopy.addEventListener('click', function (e) { config.copyToClipboard(linkObj.message, platformInput.value, copyStatus); });
        utils.tryOpenAppOrFallback(linkObj.deepLink, linkObj.fallbackLink);
      }
    }
  });
  let sendToFriendModal = new bootstrap.Modal(document.getElementById(id),
    {
      backdrop: "static",
      keyboard: false,
    });
  //sendToFriendModal.show();
}
// fallback function

// Survey submitSurvey api erorr
export function createSurveyModal(settingData, key) {
  if (utils.getCookie(key) != null)
    return;
  if (utils.getCookie(config.noParticipantKey) != null)
    return;
  let container = document.getElementsByClassName("main-container");
  if (!container.length) return;

  let mdContainer = document.createElement("div");
  const id = "surveyModal";
  mdContainer.classList.add("modal", "fade", "show");
  mdContainer.setAttribute("id", id);
  mdContainer.setAttribute("tabindex", "-1");
  mdContainer.setAttribute("role", "dialog");
  mdContainer.setAttribute("aria-labelledby", "exampleModalLongTitle");
  mdContainer.setAttribute("aria-hidden", "true");

  let modal_Dialog = document.createElement("div");
  modal_Dialog.classList.add("modal-dialog", "modal-dialog-centered");
  modal_Dialog.setAttribute("role", "document");
  mdContainer.appendChild(modal_Dialog);

  let modal_content = document.createElement("div");
  modal_content.classList.add("modal-content");
  modal_Dialog.appendChild(modal_content);

  let modal_header = document.createElement("div");
  modal_header.classList.add("modal-header");
  modal_content.appendChild(modal_header);

  let modal_h5 = document.createElement("h5");
  modal_h5.innerHTML = "شاركنا رأيك";
  modal_h5.classList.add("modal-title");
  modal_header.appendChild(modal_h5);

  // let closeButton = document.createElement("button");
  // closeButton.classList.add("btn-close");
  // closeButton.setAttribute("data-bs-dismiss", "modal");
  // modal_header.appendChild(closeButton);

  let modal_body = document.createElement("div");
  modal_body.classList.add("modal-body");

  let form = document.createElement("form");
  form.setAttribute("id", "surveyForm");

  form.innerHTML = `
    <h5 class="modal-title text-center mb-4" style="font-size:1rem!important;text-align:right!important;margin-bottom:3px!important;">
      💡 رأيك يساعدنا في تطوير الموقع ومعرفة متطلباتك لخدمتك!
    </h5>
    <div class="mb-3">
      <label class="form-label">الاسم <span class="text-danger">*</span></label>
      <input type="text" placeholder="أكتب أسمك هنا" id="name" class="form-control" required>
    </div>

    <div class="mb-3">
      <label class="form-label">ما تقييمك لموقعنا؟ (1 = غير مرضٍ، 5 = ممتاز)</label>
      <div id="ratingOptions" class="d-flex justify-content-between mb-2">
        ${[1, 2, 3, 4, 5].map(num => `
                <div>
                    <input required type="radio" id="rate${num}" name="rating" value="${num}" class="form-check-input">
                    <label for="rate${num}" class="form-check-label">${num}</label>
                </div>
            `).join("")}
      </div>
      <div id="rating" class="rating">
        <i class="fa fa-star" data-value="1"></i>
        <i class="fa fa-star" data-value="2"></i>
        <i class="fa fa-star" data-value="3"></i>
        <i class="fa fa-star" data-value="4"></i>
        <i class="fa fa-star" data-value="5"></i>
      </div>
      <input type="hidden" id="ratingValue" value="0">
    </div>

    <div class="mb-3">
      <label class="form-label">هل واجهت صعوبات في استخدام الموقع؟</label>
      <div>
        <input type="radio" name="difficulty" value="no" id="no" class="form-check-input" checked>
          <label for="no" class="form-check-label">لا</label>
          <input type="radio" name="difficulty" value="yes" id="yes" class="form-check-input">
            <label for="yes" class="form-check-label">نعم</label>
          </div>
      </div>
      <div class="mb-3" id="difficultyReasonDiv" style="display: none;">
        <label class="form-label">ما هي المشكلة التي واجهتك؟</label>
        <textarea id="difficultyReason" class="form-control" rows="2"></textarea>
      </div>

      <div class="mb-3">
        <label class="form-label">أخبرنا برأيك لتحسين الموقع</label>
        <textarea id="suggestions" class="form-control" rows="3"></textarea>
      </div>
      `;

  modal_body.appendChild(form);
  // Success Message - Initially Hidden
  let successMessage = document.createElement("div");
  successMessage.setAttribute("id", "successMessage");
  successMessage.classList.add("text-center", "d-none");
  successMessage.innerHTML = `
      <i class="fa fa-check-circle text-success display-4 big-icon"></i>
      <h4 class="mt-3"> تم إرسال الاستطلاع بنجاح!</h4>
      <p>شكرًا لمساهمتك في تطوير الموقع. نحن نقدر رأيك!</p>
      <button class="btn btn-secondary mt-3" data-bs-dismiss="modal">غلق</button>
      `;
  modal_body.appendChild(successMessage);
  modal_content.appendChild(modal_body);

  let modal_footer = document.createElement("div");
  modal_footer.classList.add("modal-footer");

  let submitButton = document.createElement("button");
  submitButton.classList.add("btn", "btn-primary");
  submitButton.innerText = "إرسال";
  var data = {};
  submitButton.onclick = async function (e) {
    e.preventDefault();
    // validate form
    if (!validation.validateRequiredFields()) return;
    let ratingSelected = document.querySelector("input[name='rating']:checked");
    let ratingOptions = document.getElementById("ratingOptions");
    if (!ratingSelected) {
      ratingOptions.classList.add('check-radio-buttons-warning');
      const warning = ratingOptions.nextElementSibling;
      warning.classList.add('show');
      return;
    } else {
      ratingOptions.classList.remove('check-radio-buttons-warning');
    }
    submitButton.disabled = true;
    data = {
      name: document.getElementById("name").value.trim(),
      rating: parseInt(document.getElementById("ratingValue").value),
      difficulty: document.querySelector("input[name='difficulty']:checked")?.value === "yes" ? 1 : 0,
      difficultyReason: document.getElementById("difficultyReason").value.trim(),
      suggestions: document.getElementById("suggestions").value.trim(),
      sId: config.sessionid
    };
    await apihandler.submitSurvey(data);
    document.querySelector('.modal-footer').style.display = "none";
    document.querySelector('.modal-header').style.display = "none";
    document.getElementById("surveyForm").classList.add("d-none");
    document.getElementById("successMessage").classList.remove("d-none");
    utils.setCookie(key, 1, 1440); //month
  };

  let disagreeButton = document.createElement("button");
  disagreeButton.classList.add("btn", "btn-secondary");
  disagreeButton.innerText = "غير مهتم";
  disagreeButton.setAttribute("data-bs-dismiss", "modal");
  disagreeButton.onclick = async function (e) {
    data.name = "غير مهتم";
    data.rating = 0;
    data.difficulty = 0;
    data.difficultyReason = '';
    data.suggestions = '';
    data.sId = config.sessionid;
    await apihandler.submitSurvey(data);
    utils.setCookie(config.noParticipantKey, 1, 72);
  };
  modal_footer.appendChild(submitButton);
  modal_footer.appendChild(disagreeButton);
  modal_content.appendChild(modal_footer);

  container[0].appendChild(mdContainer);

  let surveyModal = new bootstrap.Modal(document.getElementById(id),
    {
      backdrop: "static",
      keyboard: false,
    });
  surveyModal.show();

  // Handle rating selection via stars
  document.querySelectorAll("#rating i").forEach(star => {
    star.addEventListener("click", function () {
      let value = this.getAttribute("data-value");
      document.getElementById("ratingValue").value = value;
      document.querySelectorAll("#rating i").forEach(s => s.classList.remove("gold-star"));

      for (let i = 0; i < value; i++) {
        document.querySelectorAll("#rating i")[i].classList.add("gold-star");
      }

      // Update the corresponding radio button
      document.querySelector(`#rate${value}`).checked = true;
    });
  });

  // Handle rating selection via radio buttons
  document.querySelectorAll("input[name='rating']").forEach(radio => {
    radio.addEventListener("change", function () {
      let value = this.value;
      document.getElementById("ratingValue").value = value;

      // Update stars based on selection
      document.querySelectorAll("#rating i").forEach(s => s.classList.remove("gold-star"));
      for (let i = 0; i < value; i++) {
        document.querySelectorAll("#rating i")[i].classList.add("gold-star");
      }
    });
  });


  // Handle difficulty radio buttons
  document.querySelectorAll("input[name='difficulty']").forEach(input => {
    input.addEventListener("change", function () {
      document.getElementById("difficultyReasonDiv").style.display = this.value === "yes" ? "block" : "none";
    });
  });
}

/**
 * write a new setting to settingData
 * @returns {void}
      */
export function changeModalMessage() {
  if (typeof settingData === 'undefined') {
    return;
  }
  if (settingData.general.bodyModal != undefined) {
    if (settingData.general.categoryUrl == "rm" ||
      settingData.general.categoryUrl == "occasions" ||
      settingData.general.categoryUrl == "certs" ||
      settingData.general.categoryUrl == "kids") {
      settingData.general.bodyModal = `كل عام وأنتم بخير! 🌙🕌 \nاحصل على المزيد من التصميمات المجانية بمجرد مشاركة منشورنا على صفحتك! مشاركتك تساعد في نشر الموقع ليستفيد المزيد من المستخدمين، كما تمنحك وصولًا أكبر إلى تصاميم مميزة مجانًا.
    قم بالمشاركة الآن، وبعدها سيتم توجيهك تلقائيًا إلى هنا لتحميل تصميمك. \nشكرًا لك على دعمك المستمر! ❤️`;
    }
  }
}
/**
 * not useful function
 * @param {string} url
      */
export function createWarningImageDownload(url) {
  let userAgent = navigator.userAgent.toLowerCase();
  let isFacebookApp = userAgent.includes('fbav') || userAgent.includes('fb_iab') || userAgent.includes('fb4a');
  let isAndroid = userAgent.indexOf('android') > -1;
  let isIOS = /ipad|iphone|ipod/.test(userAgent) && !window.MSStream;


  if (isFacebookApp) {
    let linkUrl = url;
    var warningDivExists = document.querySelector('.download-warning');
    if (warningDivExists == null) {
      if (isAndroid) {
        linkUrl = `intent://${url.replace(/^https?:\/\//, '')}#Intent;scheme=https;package=com.android.chrome;end`;
      } else if (isIOS) {
        linkUrl = url;
      }

    }
  }
}




export function createDynamicErrorMessage() {

  const message = "عفوا، لقد نفذت عدد المحاولات الخاصة بكم في الوقت الحالي حاول مرة أخرى في وقت لاحق."
  const htmlErrorMessage = `<div class="text-center"><div class="alert alert-danger" role="alert"><i class="fas fa-exclamation-triangle fa-3x"></i><p class="mt-3" style="font-size:1.1rem">${message}</p>
      </div></div`;
  const boxContainer = document.querySelector('.box-container');
  const imageDesigned = document.querySelector(".image-designed");
  const desktopWarning = document.querySelector('.desktop-warning');

  if (boxContainer) boxContainer.style.minHeight = "0";
  if (imageDesigned) imageDesigned.innerHTML = htmlErrorMessage;
  if (desktopWarning) desktopWarning.innerHTML = "";
}

export function createMessage(message, divclass) {
  var content =
    '<div class="message" style="display: block !important"> <div class="details"><p class="body">' +
    message +
    ' </p> <div> <a  target="_blank" href="#"class="fb-xfbml-parse-ignore btn btn-primary postshare"> <i class="fab fa-facebook"></i> مشاركة</a> </div> <div class="errormessage"></div> </div></div>';
  const conatiner = document.querySelector(divclass);
  if (conatiner) {
    conatiner.innerHTML = content;
  }

}


export function createErrorInfo() {
  var currentUrl = location.href.replace("#gsc.tab=0", "");
  var html = `<div class="row justify-content-center mt-5"><div class="col-md-6"><div class="alert alert-danger text-center" role="alert"><i class="fas fa-exclamation-triangle fa-3x mb-3"></i> <p>حدث خطأ أثناء تنفيذ التصميم</p><p>يرجى الضغط على زر <strong>إعادة المحاولة</strong></p><a href="${currentUrl}" class="btn btn-primary mt-3">إعادة المحاولة</a></div></div></div>`
  return html;
}
export function createErrorAndNavigateToIndex() {
  var currentUrl = window.location.origin + "/" + config.designName;
  currentUrl = currentUrl.replace("#gsc.tab=0", "");
  var html = `<div class="row justify-content-center mt-5"><div class="col-md-6"><div class="alert alert-danger text-center" role="alert"><i class="fas fa-exclamation-triangle fa-3x mb-3"></i> <p>حدث خطأ أثناء تنفيذ التصميم</p><p>يرجى الضغط على زر <strong>إعادة المحاولة</strong></p><a href="${currentUrl}" class="btn btn-primary mt-3">إعادة المحاولة</a></div></div></div>`
  return html;
}
export function createWarningForDesktop() {
  var html = `<div class="col-md-8 col-lg-8 col-xl-8 desktop-warning"><div class="alert alert-warning alert-dismissible fade show" role="alert"><i class="fas fa-exclamation-circle"></i><strong> تحذير!</strong> يبدو أنك تستخدم متصفح الويب على جهاز كمبيوتر أو لابتوب.<p style="margin-top:5px;margin-right:7px;padding:2px;text-align:right">نود التنويه إلى أنه من الأفضل استخدام متصفح الهاتف المحمول لتجربة أفضل وأكثر سهولة في التصفح حتى تتمكن من الحصول على مجموعة أكبر من التصميمات المجانية المتاحة لدينا</p><button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div></div>`;

  return html;
}
export function createHowToSaveImageDescription() {
  return;
  let fbUserMessage = `<p> أنت الآن تتصفح الموقع من خلال متصفح تطبيق فيسبوك، وهذا يقيّد بعض الميزات مثل عرض الصور أو حفظها.</p>
      <p>📌 <strong>ننصحك بعدم استخدام متصفح فيسبوك لتصفح المواقع</strong>. إليك الحلول الممكنة لتجربة أفضل:</p>
      <p><strong>🔹 الطريقة الأولى:</strong>
        انسخ رابط الموقع وافتحه في متصفح خارجي على جهازك مثل "Google Chrome" أو "Safari".
      </p>
      <p><strong>🔹 الطريقة الثانية:</strong>
        ستلاحظ وجود أيقونة فوق الصورة مكتوب عليها <strong>"لحفظ الصورة اضغط هنا"</strong>.
        عند الضغط، سيتم تحميل التصميم مباشرة على جهازك. هذه الطريقة تعمل داخل متصفح فيسبوك.</p>
      <p><strong>🔹 الطريقة الثالثة:</strong><br>
        إذا لم لظهر التصميم اسفل هذا الشرح، تقدر توصله من خلال <strong>قائمة في أعلى يمين الشاشة</strong> بهذا الشكل
        ☰ اضغط عليها ثم اختر "سجل تصميماتي".</p>`;

  let chromeUserMessage = `
      <p><strong>🔹 الطريقة الاولى:</strong>
        ستلاحظ وجود أيقونة فوق الصورة مكتوب عليها <strong>"لحفظ الصورة اضغط هنا"</strong>.
        عند الضغط، سيتم تحميل التصميم مباشرة على جهازك. هذه الطريقة تعمل داخل متصفح فيسبوك.</p>


      <p><strong>🔹 الطريقة الثانية:</strong><br>
        إذا لم لظهر التصميم اسفل هذا الشرح، تقدر توصله من خلال <strong>قائمة في أعلى يمين الشاشة</strong> بهذا الشكل
        ☰ اضغط عليها ثم اختر "سجل تصميماتي".</p>
      `;
  var html = `<div class="box-header-description">
        <h5><i class="fas fa-info-circle"></i> كيف يمكن تحميل التصميم ؟
        </h5></div>
      <div class="p-how-to-design col-sm-12 col-xl-10">
        ${utils.isFacebookApp() ? fbUserMessage : chromeUserMessage}
        <p>في حالة لم تفلح معك الطرق السابقه يرجى أعلامنا بالخطأ حتى نستطيع اصلاحه سريعا وتذكر ان الدال على الخير كفاعله
          <a href="https://m.me/Design.a.card.with.your.name" class="btn btn-primary"><i class="fab fa-facebook-f" style="margin-left:5px"></i>اضغط هنا للتواصل معنا</a>
        </p>
      </div>`;

  let container = document.querySelector('.main-container');
  let how_to_design = document.createElement("div");
  how_to_design.setAttribute("class", "description designdownload box-container col-sm-12 col-md-11 col-lg-11 col-xl-11");
  how_to_design.innerHTML = html;
  if (container == undefined)
    return;
  let boxContainer = document.querySelector(".box-container");
  if (boxContainer == undefined)
    return;

  if (container.contains(boxContainer)) {
    container.insertBefore(how_to_design, boxContainer);
  }
}


//fire hamburger menus events 
export function fireHamburgerMenuEvents() {
  /*Menu events in pure Javascript */
  const menuBtn = document.querySelector('.menu-btn');
  const wrapper = document.querySelector('.wrapper'); // for pages
  const body = document.body;
  let scrollPosition = 0
  menuBtn.addEventListener('change', function () {
    if (this.checked) {

      scrollPosition = window.scrollY;
      // Open menu: Shift content to the left
      wrapper.classList.remove('closing');
      wrapper.classList.add('menu-open');
      // wrapper.classList.add('menu-open');
      body.classList.add('no-scroll'); // Add class to body

      // body.style.position = 'fixed';
      body.style.top = `-${scrollPosition}px`;
    } else {
      // Close menu: Wait for the transition to complete before removing the shift
      wrapper.classList.add('closing'); // Add a closing class
      //wrapper.classList.add('closing');
      //  wrapper.classList.remove('menu-open');
      wrapper.classList.remove('menu-open'); // Remove the open class
      body.classList.remove('no-scroll'); // Remove class from body
      document.body.style.position = '';
      body.style.top = '';
      window.scrollTo({
        top: scrollPosition,
        behavior: 'instant',
      });
      wrapper.addEventListener(
        'transitionend',
        () => {
          wrapper.classList.remove('closing');
        },
        { once: true } // Ensure the event listener is removed after firing
      );
    }
  });
  /*end menu events in pure Javascript */
}
// fire Animation for elements
export function fireSmoothAnimation() {
  /*Animation javascript pure */
  // Add this if you want animations only when element scrolls into view
  const observer = new window.IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.animationPlayState = 'running';
      }
    });
  });

  document.querySelectorAll('.description, .box-header-description, .p-content, .link-title, .link-description, .btn-primary').forEach(el => {
    el.style.animationPlayState = 'paused';
    observer.observe(el);
  });
}
/**
 * change the footer content in a dynamic way
 */
export function changeFooterDiv() {
  const footer = document.querySelector('footer.page-footer');
  if (!footer) return;
  const mt4 = footer.querySelector('.mt-4');
  if (!mt4) return;

  let constSmall = mt4.getElementsByTagName('small');
  if (constSmall.length > 0) {
    constSmall[0].innerHTML = " &copy;حقوق النشر 2026  محفوظة لشركة ProNileSoft ";
  }
  let constStrong = mt4.getElementsByTagName('strong');
  if (constStrong.length > 0) {
    constStrong[0].innerHTML = "";
  }
}
/**
 * create checkboxes for input to save input data
 * @returns {void}
      */
export function buildCheckBoxesForInputs() {
  let textboxes = settingData.textBoxes;
  if (textboxes.length == 1) {
    return;
  }
  for (let i = 0; i < textboxes.length; i++) {
    let input = textboxes[i];
    createCheckBoxForInput(input.id);
  }
}
/**
 *
 * @param {string} id of input text
      * @returns
      */
export function createCheckBoxForInput(input) {
  const inputElement = document.getElementById(`${input}`);
  const sessionStorageKey = `${config.designName}_${input}`;
  if (inputElement == null) {
    return "";
  }
  if (inputElement.style.display == "none") {
    return "";
  }
  const parent = inputElement.closest("div");
  const checkInputDiv = document.createElement("div");
  checkInputDiv.className = "form-check";
  let html = "";
  let id = `chk_${input}`;
  html += `<input class="form-check-input" type="checkbox" id="${id}" checked>
        <label class="form-check-label" for="${id}">
          تثبيت هذاالحقل تلقائيًا
        </label>`;
  checkInputDiv.innerHTML = html;
  parent.appendChild(checkInputDiv);
  // add event click to checkbox by javascript pure
  const checkbox = document.getElementById(`${id}`);
  if (checkbox) {
    checkbox.addEventListener('click', function (e) {
      if (!checkbox.checked) {
        // remove data from session
        window.sessionStorage.removeItem(sessionStorageKey);
      }
    });
  }
}
/**
 * hide loader-container class div
 */
export function hideLoaderContainer() {

  const loader = document.querySelector(".loader-container");
  if (loader) loader.style.display = "none";
}
/**
* show loader-container class div
*/
export function showLoaderContainer() {

  const loader = document.querySelector(".loader-container");
  if (loader) loader.style.removeProperty('display');
}
/**
 * show a short confirmation toast at the bottom of the screen
 * (pure feedback - e.g. after the user starts downloading the result;
 * it never changes the flow that triggered it)
 * @param {string} message - text shown inside the toast
 */
export function showToast(message) {
  let container = document.getElementById("appToastContainer");
  if (!container) {
    container = document.createElement("div");
    container.id = "appToastContainer";
    container.className = "toast-container position-fixed bottom-0 start-50 translate-middle-x p-3";
    container.style.zIndex = "1090";
    document.body.appendChild(container);
  }
  let toastEl = container.querySelector(".app-toast");
  if (!toastEl) {
    toastEl = document.createElement("div");
    toastEl.className = "toast app-toast align-items-center";
    toastEl.setAttribute("role", "status");
    toastEl.setAttribute("aria-live", "polite");
    toastEl.innerHTML = `
      <div class="d-flex align-items-center">
        <span class="app-toast-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 10"></polyline></svg></span>
        <div class="toast-body app-toast-body"></div>
        <button type="button" class="btn-close app-toast-close" data-bs-dismiss="toast" aria-label="إغلاق"></button>
      </div>`;
    container.appendChild(toastEl);
  }
  toastEl.querySelector(".app-toast-body").textContent = message;
  bootstrap.Toast.getOrCreateInstance(toastEl, { delay: 4500 }).show();
}
/**
 * file name for a saved result, following the platform's own flow: the
 * token in the download page's URL - unique per design, so repeated
 * downloads never land on the same name. The extension comes from the
 * file URL when it carries one, else from the blob's type. Without a
 * token, the URL's last segment is used, then a plain default.
 * @param {string} url - the download URL
 * @param {string} [blobType] - MIME type of the fetched blob, if any
 * @returns {string} file name to save the download under
 */
export function downloadFileName(url, blobType = "") {
  let segment = "";
  try {
    segment = new URL(url, window.location.href).pathname.split("/").pop() || "";
  } catch (error) { /* keep the empty segment and use the defaults below */ }
  let extension = "";
  const dot = segment.lastIndexOf(".");
  if (dot > 0) extension = segment.slice(dot).toLowerCase();
  if (!extension) {
    const byType = { "image/jpeg": ".jpg", "image/png": ".png", "image/webp": ".webp", "video/mp4": ".mp4" };
    extension = byType[blobType] || ".jpg";
  }
  const token = new URLSearchParams(window.location.search).get("token");
  if (token) return token + extension;
  if (segment.includes(".")) return decodeURIComponent(segment);
  if (segment) return segment + extension;
  return "design" + extension;
}
/**
 * save a file from a URL onto the device, the way the editor's export does:
 * fetch it as a blob and trigger the download from a same-origin object URL.
 * Needed because browsers ignore the download attribute on cross-origin
 * links (the render servers) and merely open the file in the browser.
 * @param {string} url - cross-origin URL of the rendered file
 * @returns {Promise<boolean>} true when the save was triggered; false when
 *          the fetch failed and the caller should open the URL as before
 */
export async function saveUrlAsFile(url) {
  try {
    const response = await fetch(url);
    if (!response.ok) return false;
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const saver = document.createElement("a");
    saver.href = objectUrl;
    saver.download = downloadFileName(url, blob.type);
    document.body.appendChild(saver);
    saver.click();
    saver.remove();
    setTimeout(() => URL.revokeObjectURL(objectUrl), 4000);
    return true;
  } catch (error) {
    return false;
  }
}
/**
 * show image container of preview images
 */
export function showImagesContainer() {
  document.querySelectorAll('.images-container').forEach(el => {
    el.style.removeProperty('display');
  });
}
/**
 * disable inputs in the current page
 */
export function disableUserInput() {
  document.querySelectorAll('input:text, .btn').forEach(el => el.setAttribute("disabled", "disabled"));
  document.querySelectorAll('input[type="hidden"]').forEach(el => {
    el.name = '';
    el.id = '';
    el.value = '';
  });
}

/**
 * Restricts access for certain users.
 */
export function restrictUserAccess(mainContainer, logUser) {
  if (!utils.rqown()) {
    if (mainContainer) {
      mainContainer.innerHTML = `
      <div class="container" style="display:flex;justify-content:center;align-items:right;margin-top:8px">
        <div class="alert alert-danger" role="alert" style="max-width:500px;width:100%">
          <div class="d-flex align-items-right">
            <div>
              <i class="fas fa-exclamation-triangle" style="font-size:1.8rem;position:relative;top:1px;margin-right:-6px"></i>
              <strong style="font-size:1rem;margin-right: 3px;">لا يمكنك تصفح الموقع</strong>
              <p style="margin-top:8px;margin-right:20px">
                نطلب منك التأكد من عدم استخدام برامج تغير عنوان الشبكة لديك أو البروكسي، حيث يتعارض استخدامها مع سياسات الموقع.
              </p>
              <p style="font-weight:700;text-align:center">شكرًا لتفهمك وتعاونك.</p>
            </div>
          </div>
        </div>
      </div>`;
    }
    logUser.dotnetHost = "Using proxy";
  } else {
    logUser.dotnetHost = "Wael Sayed";
  }
  apihandler.logUsersOfDesign(logUser);
}
export function forbiddenUserBlockCookies(main, dataCloud) {
  if (main) {
    main.innerHTML = '';
    createErrorWhenDisableCookies(main);
  }
  config.isUserdisabledcookies = true;
  // log the user
  let url = window.location.href;
  apihandler.logUsers(url, "", "", "Cookies disabled", "", config.ref, dataCloud);
}
/**
 *
 * @param {string} current dom
        */
function createErrorWhenDisableCookies(main) {
  const div = `<div class="container mt-5"><div class="alert alert-warning alert-dismissible fade show custom-warning" role="alert"><strong>يرجى تمكين ملفات الارتباط (الكوكيز)!</strong><p>لان لها دورًا أساسيًا في استقرار وظيفة الموقع وبدونها لن تستطيع عمل اي تصميم</p><button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div><div class="text-right"><p>للمزيد من المساعدة، لا تتردد في التواصل معنا </p><a href="https://m.me/Design.a.card.with.your.name" class="btn btn-primary"><i class="fab fa-facebook-f" style="margin-left:5px"></i>التواصل على فيسبوك</a></div></div>`
  main.innerHTML = div;
}

export function fireWarningForPc() {

  if (!config.isUserBlockedCookies && !config.isUserProxyRequest) {
    // let totalDownload = getCookie(totaldowloadKey);
    // if(totalDownload!=undefined){
    //   let maxDownloadForPc = parseInt(maxTotalDownloadPerCountry * 0.75 );

    //   setCookie(totaldowloadKey,maxDownloadForPc,8);
    // }
    let cn = document.createElement("div");
    let breadcrumb = document.getElementsByClassName('breadcrumb');
    if (breadcrumb.length > 0) {
      cn.innerHTML = createWarningForDesktop();
      breadcrumb[0].append(cn);
      closeWaringPCWithFadeEffect();
    }
  }
}

function closeWaringPCWithFadeEffect() {
  document.querySelectorAll('.btn-close').forEach(button => {
    button.addEventListener('click', function () {
      document.querySelectorAll('.alert').forEach(alert => {
        // Apply fade out animation
        alert.style.transition = 'opacity 600ms ease';
        alert.style.opacity = '0';
        // Hide element after animation
        window.setTimeout(() => {
          alert.style.display = 'none';
          // Reset opacity for potential reuse
          alert.style.opacity = '1';
        }, 600);
      });
    });
  });
}
/**
 * remove style from download box
 * @param {string} remove
        * @param {string} add
        */
export function removeStyleFromDownloadBox(remove, add) {
  let box = document.getElementsByClassName('box-image');
  if (box.length > 0) {
    if (remove)
      box[0].setAttribute("style", "box-shadow:none;border:0;");
    else
      box[0].setAttribute("style", "box-shadow:0 4px 6px rgba(0, 0, 0, 0.1);border:1px solid #dee2e6;");
  }
}
/**
 * hide element in dom by className
 * @param {string} className
        */
export function hideDomByClassName(className) {
  const element = document.querySelector(`.${className}`);
  if (element) {
    element.style.removeProperty('display');// fix the problem of hidden element

  }
  // If element doesn't exist → do nothing, no error
}
/**
 * Show element(s) in DOM by className
 * @param {string} className - The class name (without dot)
        * @param {string} [displayType="block"] - CSS display value: 'block', 'flex', 'grid', 'inline-block', etc.
        */
export function showDomByClassName(className, displayType = "block") {
  // Guard clauses – prevent errors in any environment
  if (!className || typeof className !== "string") return;
  if (typeof document === "undefined") return; // Safe for SSR (Next.js, etc.)

  const selector = `.${className.trim()}`;
  const elements = document.querySelectorAll(selector);

  // querySelectorAll never returns null → always a NodeList
  elements.forEach(el => {
    if (el && el.style) {
      el.style.display = displayType;

    }
  });
}
/**
 * Creates an error message div with icon and appends it to a parent element
 * @param {string} message - The error text to display
        * @param {string} parentSelector - CSS selector of the parent (e.g. ".error-container" or "#form")
        */
export function createErrorDiv(message, parentSelector) {
  // Create the <p> element
  const errorP = document.createElement('p');
  errorP.style.cssText = `
          font-size: 0.95rem;
          color: #f00;
          margin-right: 8px;
          text-align: center;
          height: 130px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          `;

  // Create the icon <i>
  const icon = document.createElement('i');
  icon.className = 'fas fa-2x fa-exclamation-circle';
  icon.style.color = '#f00';
  icon.style.marginLeft = '10px'; // or use flex gap above

  // Append icon and text to paragraph
  errorP.appendChild(icon);
  errorP.appendChild(document.createTextNode(message));

  // Append to parent (safe check)
  const parent = document.querySelector(parentSelector);
  if (parent) {
    parent.appendChild(errorP);
  } else {
    console.warn(`Parent element not found: ${parentSelector}`);
  }
}

export function createglMessage() {
  let message = "حدث مشكلة اثناء التصميم ربما تكون مشكلة برمجية من فضلك قم بالتواصل معنا على صفحتنا على الفيسبوك  حتى نستطيع العمل على حل المشكلة سريعا والاستمرار في تقديم الخدمات المجانية لجميع الزائرين.";
  let htmlErrorMessage = `<div class="text-center"><div class="alert alert-danger" role="alert"><i class="fas fa-exclamation-triangle fa-3x"></i><p class="mt-3" style="font-size:1rem;">${message}</p>
              <div class="text-center"><a href="http://m.me/Design.a.card.with.your.name" class="btn btn-primary" style="min-width:200px;padding:8px">تواصل الان</a></div></div></div>`;
  let notValidDownloadMessage = `<div>
              <strong> عذرًا! يبدو أنك تجاوزت الخطوة الأولى.</strong>
            </div>
            <div class="mt-2">
              يجب عليك إدخال بيانات التصميم في صفحة البداية قبل الوصول إلى هذه الصفحة.
            </div>`;
  let notValidDownloadhtmlDivError = `
            <div class="text-center">
              <div class="alert alert-danger" role="alert">
                <div style="font-size: 2.5rem;">⚠️</div>
                <p class="mt-3" style="font-size:1rem;">${notValidDownloadMessage}</p>
                <div class="text-center mt-4">
                  <a href="./" class="btn btn-primary" style="min-width:200px;padding:8px">
                    يمكنك الرجوع من هنا
                  </a>
                </div>

              </div>
            </div>
            `;
  const imageDesigned = document.querySelector(".image-designed");
  const loaderContainer = document.querySelector(".loader-container");
  const desktopWarning = document.querySelector('.desktop-warning');

  if (imageDesigned) {
    if (!config.isDownloadPageValid) {
      imageDesigned.innerHTML = notValidDownloadhtmlDivError;
    } else {
      imageDesigned.innerHTML = htmlErrorMessage;
    }
    imageDesigned.style.removeProperty('display');
  }
  if (loaderContainer) {
    loaderContainer.style.display = "none";
  }
  if (desktopWarning) {
    desktopWarning.innerHTML = "";
  }
}

/**
 * Creates a Facebook share message with arrow animation and share button
 * @param {string} message - Text to display (e.g. "شارك تصميمك الآن!")
            * @param {object} settingData - Your settings object (used in createFbUrl)
            * @param {string} parentSelector - CSS selector of parent (e.g. ".share-section")
            * @param {string} [designName] - Optional design name (if needed by createFbUrl)
            */
export function createFbShareMessage(message, settingData, parentSelector, designName) {
  // Guard clauses - prevent crashes
  if (!message || !parentSelector || typeof document === "undefined") return;

  //const parent = document.querySelector(parentSelector);

  if (!parentSelector) {
    console.warn(`Parent element not found: ${parentSelector}`);
    return;
  }

  const appId = "286287053106964";
  const pageId = "Design.a.card.with.your.name";

  // Clean URL (remove Facebook cancel garbage + add flag for iOS)
  let url = location.href.replace(
    /&error_code=4201&error_message=User%20canceled%20the%20Dialog%20flow#_=_/g,
    ""
  ).replace(/#_=_$/, ""); // extra cleanup

  url += (url.includes("?") ? "&" : "?") + "fbback=y"; // fix iOS cookie issue
  const encodedUrl = encodeURIComponent(url);

  // Assume you have this function already (or paste it below)
  const fbUrl = utils.createFbUrl(appId, settingData, pageId, designName, encodedUrl);

  // === 1. Message paragraph ===
  const pMessage = document.createElement("p");
  pMessage.style.cssText = `
            font-size: 0.95rem;
            color: #000;
            margin-right: 8px;
            text-align: center;
            margin-top: 20px;
            font-weight: 500;
            `;
  pMessage.textContent = message;

  // === 2. Bouncing arrow ===
  const divArrow = document.createElement("div");
  divArrow.className = "arrow bounce";

  const aArrow = document.createElement("a");
  aArrow.className = "fa fa-arrow-down fa-2x";
  aArrow.href = "javascript:void(0);"; // optional: make it non-clickable
  aArrow.style = "cursor: default;font-size: 2rem;";
  aArrow.innerHTML = "👇";
  divArrow.appendChild(aArrow);

  // === 3. Facebook Share Button ===
  const aFb = document.createElement("a");
  aFb.href = fbUrl;
  aFb.target = "_blank";
  aFb.rel = "noopener"; // security best practice
  aFb.className = "fb-xfbml-parse-ignore btn btn-primary postshare";
  aFb.style.cssText = "font-size:1.1rem; margin: 20px auto;margin-top:2px; display: inline-flex; align-items: center; gap: 8px; padding: 10px 20px;";

  aFb.innerHTML = ` مشاركة 	<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-facebook" viewBox="0 0 16 16">
						<path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
					</svg>`;



  // === Append all to parent ===
  parentSelector.appendChild(pMessage);
  parentSelector.appendChild(divArrow);
  parentSelector.appendChild(aFb);
}

/**
 * the most important function to show modal to user
 * @param {object} settingData 
 * @returns {void}
 */
export function showModalBasedOnShare(settingData) {
  let isShowModal = config.ShowModal ?? false;
  let isSharedLink = config.isSharedLink ?? false;
  const isShareToday = utils.getLocalStorageValue(config.sharedTodayKey);
  // if the user share any link today return
  if (isShareToday) {
    return;
  }
  // if (config.domain.indexOf('localhost') != -1) {
  //   return;
  // }
  if (utils.isResultPage()) {
    removeStyleFromDownloadBox(false, true);
    // check if the method run before or not 
    if (!isShowModal) {
      return;
    }
    // validate before check
    var fbBack = utils.getQueryValue("fbback");
    let isAcceptCookies = navigator.cookieEnabled;
    if (config.ShowModal) {
      let cookieName = "fb-" + config.designName;
      let cookie = utils.getLocalStorageValue(cookieName);

      // if force validate from design json config
      //**************FORCE VALIDATION */
      if (config.isForceShare) {
        utils.applyForceValidateShare(settingData);
      }
      else {
        // without force validation
        // if user come from facebook share and cookies not saved in browser
        // if (fbBack.substring(0, 1) == "y" && cookie != "1") {
        //   // check if the user cancel the dilaog
        //   utils.setToLocalStorage("fb-" + config.designName, "1", 4);
        //   //fillAdsenceContainers("download");
        //   //loadGoogleadsPerPage();
        //   return;
        // }
        // let comeFrom = config.ref;
        // if (comeFrom.indexOf("facebook") > -1) {
        //   utils.setToLocalStorage("fb-" + config.designName, "1", 4);
        //   //  fillAdsenceContainers("download");
        //   //loadGoogleadsPerPage();
        //   return;
        // }

        // if the user not come from facebook app and not user not applicable
        if (!utils.isFacebookApp() && !config.isUserNotApplicable) {
          utils.setToLocalStorage("fb-" + config.designName, "1", 4);
          showModel(cookie);
          return;
        }


        // if cookies saved and user try to make another design
        // if (cookie != "1" && !isDesktop() ) {
        // show message
        if (cookie != "1") {
          if (!config.isUserNotApplicable) {
            utils.setToLocalStorage("fb-" + config.designName, "1", 4);
            showModel(cookie);
            return;
          } else {
            showModel(cookie);
            return;
            // show adds if UserNotApplicable
            //  fillAdsenceContainers("download"); 
            //loadGoogleadsPerPage();
          }
        }

        // if not show ads
        // else {
        //   fillAdsenceContainers("download");
        //   loadGoogleadsPerPage();
        //   return;
        // }
      }

    }
    //NORMAL CASE NO SHARE
    // if it has not showModal option show ads
    // else {
    //   // fillAdsenceContainers("download");
    //   // loadGoogleadsPerPage();
    // }
  }
}
export function changeModalStatus() {
  let modalFooter = document.getElementsByClassName("modal-footer");
  if (modalFooter.length == 0) return;
  let isExists = document.getElementById("btnReloadEvent");
  if (isExists == null) {
    var alink = document.createElement('a');
    alink.classList.add("btn", "btn-secondary");
    alink.setAttribute("href", "#");
    alink.setAttribute("id", "btnReloadEvent");
    alink.setAttribute("onclick", "location.reload();");
    alink.text = "أضغط هنا لو قمت بالمشاركة";
    modalFooter[0].append(alink);
  }
}
/**
 * Smoothly scrolls the page so that the .image-designed element is centered in the viewport
 */
export function scrollToDownloadImage() {
  const element = document.querySelector('.image-designed');

  if (!element) {
    console.warn('Element with class "image-designed" not found');
    return;
  }

  // Get element position and size
  const rect = element.getBoundingClientRect();
  const elementTop = rect.top + window.scrollY;         // Absolute top position
  const elementHeight = rect.height;

  // Calculate middle of the element
  const middleOfElement = elementTop + (elementHeight / 2);

  // Viewport height
  const viewportHeight = window.innerHeight;

  // Final scroll position (centers the element vertically)
  const scrollTo = middleOfElement - (viewportHeight / 2);

  // Smooth scroll using native API (best performance & feel)
  window.scrollTo({
    top: scrollTo,
    behavior: 'smooth'
  });
}
export function createSendToFriendContainer() {
  return `<div class="card border-0 shadow-lg rounded-4 p-4 my-4 text-center bg-light">
              <div class="card-body">
                <h5 class="card-title mb-3">🎁 خصص رابط دائم للتصميم الحالي</h5>
                <p class="card-text fs-6">
                  اكتب فيه اسمك و رسالة تهنئة! وإرسل الرابط لصديقك على
                  <span class="text-primary fw-semibold">واتس اب</span> أو
                  <span class="text-primary fw-semibold">فيسبوك</span>
                </p>
                <a href="#" class="btn btn-primary btn-lg mt-2" id="openSendToFriendModal">
                  <i class="fas fa-paper-plane me-2"></i> أرسل الآن
                </a>
              </div>
            </div>`;
}
/**
 * Creates a download block (link + preview image) and returns the container element
 * @param {string} imageurl     - URL of the image to preview
            * @param {string} downloadimage - Direct download link (href for the <a>)
              * @returns {HTMLElement}       - The full <div class="col-12"> container
                */
export const createDownloadBlock = (imageurl, downloadimage) => {
  const div = document.createElement('div');
  div.className = 'col-12';
  div.style.marginBottom = '10px';

  // Download link <a>
  const a = document.createElement('a');
  a.href = downloadimage;
  a.className = 'col-12 download-T-Phone text-center';
  a.style.cssText = 'margin-bottom:5px; text-decoration:none; display:block;';

  // Icon <i>
  const i = document.createElement('i');
  i.className = 'fas fa-2x fa-download';
  i.style.marginLeft = '10px';

  a.append(i, 'لحفظ الصورة أضغط هنا');

  // Preview image <img>
  const img = document.createElement('img');
  img.src = imageurl;
  img.className = 'img-responsive center-block';
  img.style.cssText = `
                      border:1px solid #ddd;
                      padding:3px;
                      border-radius:6px;
                      max-width:100%;
                      display:block;
                      margin:10px auto;
                      `;

  // Assemble everything
  div.append(a, img);

  return div;   // ← You get the full element back!
};
/**
 * 
 * @param {Array<object>} messages 
 */
export function displayMessages(messages) {
  const messagesList = document.getElementById('messages-list');
  // vlidate messageList
  messagesList.innerHTML = ''; // Clear previous content
  messages.forEach(message => {
    const messageItem = document.createElement('a');
    messageItem.href = `messagedetails.html?messageId=${message.MessageId}`;
    messageItem.classList.add('list-group-item', 'list-group-item-action', 'd-flex', 'justify-content-between', 'align-items-center');
    if (message.isread === 0) {
      messageItem.classList.add('unread'); // Highlight unread messages
    }

    // Message content
    const messageContent = document.createElement('div');
    messageContent.classList.add("message-container");
    if (message.isread === 0) {
      let replyDetails = document.createElement('div');
      replyDetails.classList.add("reply-details");
      replyDetails.innerHTML = `<span class="badge bg-danger" style="font-size: 0.70rem!important ">جديد</span>`;
      messageContent.appendChild(replyDetails);
    }
    const truncatedMessage = message.message ? message.message.substring(0, 60) + '...' : 'No reply';
    messageContent.innerHTML += `
                    <p>${utils.cleanMessageContent(truncatedMessage)}</p>
                `;
    // Date and time
    const dateTime = document.createElement('div');
    dateTime.classList.add('textdate');
    const pdate = document.createElement('p')
    pdate.classList.add("pdate");
    //let dateOnly = message.createdAt.split(' ');
    // dateTime.textContent = dateOnly[0];
    const formatedDate = utils.formatDateOrTime(message.createdAt);
    pdate.innerHTML = `<i class="fa-solid fa-calendar-days"></i> ` + formatedDate;
    dateTime.appendChild(pdate);

    messageContent.appendChild(dateTime);
    messageItem.appendChild(messageContent);
    // Append the message item to the list
    messagesList.appendChild(messageItem);
  });

  // If no messages, display a placeholder
  if (messages.length === 0) {
    messagesList.innerHTML = `
                    <div class="list-group-item text-center text-muted">
                       لا يوجد رسائل لديك
                    </div>`;
  }
}
/**
 * 
 * @param {object} replies 
 * @returns 
 */
export function displayReplies(replies) {
  if (replies.length == 0)
    return;
  const container = document.getElementById('replies-container');
  const ownerContainer = document.querySelector('.owner-container');
  let clientName = replies[0].ClientName;
  if (!container)
    return;
  ownerContainer.innerHTML = `
            <div class="message-card ${replies[0].sendBy != "0" ? 'owner' : 'support'} ">
            <div class="message-header">
                <div class="sender">
                    <i class="fas fa-user"></i> ${clientName}
                </div>
                <div class="date">
                    <i class="fa-solid fa-calendar-days"></i> ${utils.formatDateOrTime(replies[0].createdAt)}
                </div>
            </div>
            <div class="message-body">
                <p>${replies[0].SourceMessage}</p>
            </div>
        </div>`;
  container.innerHTML = ''; // Clear previous content
  if (replies[0].sendBy === "0") {
    clientName = "أنا";
  }
  replies.forEach(reply => {
    const replyElement = document.createElement('div');
    replyElement.classList.add('message-card', `${reply.replyBy !== "0" ? 'owner' : 'support'}`);
    replyElement.innerHTML = `
                    <div class="message-header">
                        <div class="sender">
                            <i class="fas fa-user"></i> ${reply.replyBy === config.sessionid ? clientName : "دعم الموقع"}
                        </div>
                        <div class="date">
                            <i class="fa-solid fa-calendar-days"></i> ${utils.formatDateOrTime(reply.createdAt)}
                        </div>
                    </div>
                    <div class="message-body">
                        <p>${utils.cleanMessageContent(reply.message)}</p>
                    </div>
         `;
    container.appendChild(replyElement);
  });
  document.querySelector('.message-container').style = "visibility:visible;";
}
export function displayEmptyStorageMessage() {
  return `<div class="empty-container">
	 	<i class="fa-solid fa-box-open"></i>
		<p>لا يوجد اي تصميمات في السجل</p>
		</div>`;
}
export function renderDesigns() {
  let designObjects = utils.getStoredDesigns(config.historyKey); // Retrieve stored designs
  historyContainer.innerHTML = "";
  if (designObjects.length == 0) {
    historyContainer.innerHTML = displayEmptyStorageMessage();
    return;
  }
  designObjects.forEach((design, index) => {
    let fileName = design.imageName;
    // locally rendered designs live in the local store, not on a server
    let localUrl = canvasRender.getStoredImage(fileName);
    let downloadUrl = localUrl ? localUrl : `${design.host}/api/download/${fileName}`; // Construct download URL
    let imagePath = localUrl ? localUrl : `${design.host}/images/shared/${fileName}`;
    // Create div element dynamically
    let designDiv = document.createElement("div");
    designDiv.classList.add("image-designed");
    designDiv.setAttribute("id", `design_${index}`);

    designDiv.innerHTML = `<div class="container-controls" style="visibility: hidden;" id="container_${index}">
            <a target="_blank" id="save_${index}" href="${downloadUrl}" class="btn btn-primary"> حفظ
                <i class="fa-solid fa-download"></i>
            </a>
			<button onclick="confirmDelete(${index})"  id="delete_${index}" class="btn btn-danger">حذف <i class="fa-solid fa-trash-can"></i></button>
			<!--
			<div class="form-check" id="fchk_${index}">
			<input class="form-check-input" onclick="addDesign(this,${index})" type="checkbox" value="" id="chk_${index}">
			<label class="form-check-label" id="lbl_${index}" for="chk_${index}">أضغط لاضافة التصميم الي ال PDF
			</label>
			</div>	
			!-->
			<img id="img_${index}" fetchpriority="low" loading="lazy" onload="validateImage(this,${index});"  onerror="hideControls(${index});" class="center-block download-image img-template" src="${imagePath}" alt="Design Image">
			</div> `;

    historyContainer.appendChild(designDiv); // Append div to container
  });
}

